module.exports = __webpack_public_path__ + "static/media/service7.f7778bbb.jpg";